"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionsFromStatus = exports.CAMPAIGN_STATUSES_MAP = exports.CAMPAIGN_STATUSES = void 0;
var CAMPAIGN_STATUSES = exports.CAMPAIGN_STATUSES = ['Review', 'Approve', 'Draft', 'Hold', 'Pending', 'Revise', 'Scheduled', 'Running', 'Completed', 'Cancelled'];
var CAMPAIGN_STATUSES_MAP = exports.CAMPAIGN_STATUSES_MAP = {
  REVIEW: 'Review',
  APPROVE: 'Approve',
  DRAFT: 'Draft',
  HOLD: 'Hold',
  PENDING: 'Pending',
  REVISE: 'Revise',
  SCHEDULED: 'Scheduled',
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};
var getOptionsFromStatus = exports.getOptionsFromStatus = function getOptionsFromStatus(status) {
  var allowedStatuses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var statusOptions = [];
  switch (status) {
    case 'Review':
      statusOptions = ['Approve', 'Hold', 'Cancelled'];
      break;
    case 'Approve':
      statusOptions = ['Draft', 'Hold', 'Review', 'Cancelled'];
      break;
    case 'Draft':
      statusOptions = ['Pending', 'Hold', 'Review', 'Cancelled'];
      break;
    case 'Hold':
      statusOptions = ['Approve', 'Cancelled'];
      break;
    case 'Pending':
      statusOptions = ['Scheduled', 'Revise', 'Hold', 'Review', 'Cancelled'];
      break;
    case 'Revise':
      statusOptions = ['Pending', 'Cancelled'];
      break;
    case 'Scheduled':
      statusOptions = ['Running', 'Review', 'Cancelled'];
      break;
    case 'Running':
      statusOptions = ['Completed', 'Cancelled'];
      break;
    case 'Completed':
      break;
    case 'Cancelled':
      statusOptions = ['Review'];
      break;
    default:
      console.error('Invalid status provided');
  }
  if (allowedStatuses) statusOptions = statusOptions.filter(status => allowedStatuses.includes(status));
  return statusOptions;
};